(() => {
// Shopify's cross-origin preview toolbar covers viewport-fixed bottom actions.
// In draft previews keep the real, existing summary in document flow instead.
const detectPreviewBar = () => {
  if (location.hostname.endsWith('.shopifypreview.com') || document.getElementById('PBarNextFrame')) {
    document.body.classList.add('pdb-theme-preview');
    return true;
  }
  return false;
};
if (!detectPreviewBar() && 'MutationObserver' in window) {
  const previewObserver = new MutationObserver(() => {
    if (detectPreviewBar()) previewObserver.disconnect();
  });
  previewObserver.observe(document.body, {childList:true});
}
const catalog = {
      shirt: {
        name: 'Vintage western shirt', shortName: 'Western shirt', base: 75,
        bases: {
          front: { full: 'assets/shirt-front-full.webp', crop: 'assets/shirt-crop.webp' },
          back: { full: 'assets/shirt-back-full.webp', crop: 'assets/shirt-back-crop.webp' }
        },
        options: [
          { id: 'fringe-sleeves', name: 'Fringe — sleeves', detail: 'Hand-cut fringe along both sleeves', price: 15, layer: 'assets/layers/shirt-fringe-sleeves.webp', view: 'front' },
          { id: 'fringe-chest', name: 'Fringe — chest', detail: 'Placement across the western yoke', price: 15, layer: 'assets/layers/shirt-fringe-chest.webp', view: 'front' },
          { id: 'fringe-back', name: 'Fringe — back', detail: 'Movement across the back yoke', price: 15, layer: 'assets/layers/shirt-fringe-back.webp', view: 'back' },
          { id: 'crop', name: 'Crop', detail: 'Shorten and refinish the original shirt', price: 15 },
          { id: 'embroider', name: 'Embroidery', detail: 'Custom chain-stitch artwork', price: 50, layer: 'assets/layers/shirt-embroidery.webp', view: 'front' }
        ]
      },
      jacket: {
        name: 'Type III denim jacket', shortName: 'Denim jacket', base: 150,
        bases: {
          closed: { full: 'assets/jacket-front-full.webp', crop: 'assets/jacket-crop.webp' },
          open: { full: 'assets/jacket-sherpa-interior.webp', crop: 'assets/jacket-open-crop.webp' }
        },
        options: [
          { id: 'sherpa-collar', name: 'Sherpa — collar', detail: 'Add sherpa to the original collar', price: 30, layer: 'assets/layers/jacket-sherpa-collar.webp' },
          { id: 'sherpa-cuffs', name: 'Sherpa — cuffs', detail: 'Finish both cuffs in sherpa', price: 30, layer: 'assets/layers/jacket-sherpa-cuffs.webp' },
          { id: 'sherpa-sleeves', name: 'Sherpa — full sleeve', detail: 'Sherpa treatment across both sleeves', price: 50, layer: 'assets/layers/jacket-sherpa-sleeves.webp' },
          { id: 'sherpa-interior', name: 'Sherpa — full interior', detail: 'Full interior sherpa treatment', price: 60 },
          { id: 'crop', name: 'Crop', detail: 'Shorten and refinish the original jacket', price: 15 },
          { id: 'embroider', name: 'Embroidery', detail: 'Custom chain-stitch artwork', price: 50, layer: 'assets/layers/jacket-embroidery.webp' }
        ]
      }
    };

    catalog.shirt.name = 'Off-white western shirt';
    const state = { garment: 'jacket', selected: new Set(), view: 'front', slot: '' };
    const draftStore = createPapasDraftStore(catalog, () => window.sessionStorage);
    const restored = draftStore.read();
    const savedDesigns = { shirt: new Set(restored?.designs.shirt || []), jacket: new Set(restored?.designs.jacket || []) };
    if (restored) {
      state.garment = restored.garment;
      state.selected = new Set(savedDesigns[state.garment]);
      state.view = restored.view;
    }
    function rememberDesign() {
      savedDesigns[state.garment] = new Set(state.selected);
      draftStore.write({version:1,garment:state.garment,view:state.view,designs:{shirt:[...savedDesigns.shirt],jacket:[...savedDesigns.jacket]}});
    }
    const optionsEl = document.getElementById('options');
    const priceEl = document.getElementById('price');
    const noteEl = document.getElementById('selection-note');
    const imageWrap = document.getElementById('garment-wrap');
    const viewToggle = document.getElementById('view-toggle');
    const previewFeedback = document.createElement('div');
    previewFeedback.className = 'preview-feedback';
    previewFeedback.innerHTML = '<span role="status" aria-live="polite"></span><button type="button" hidden>Retry preview</button>';
    imageWrap.parentElement.append(previewFeedback);
    const previewStatus = previewFeedback.querySelector('span');
    const previewRetry = previewFeedback.querySelector('button');
    const showPreview = createPapasPreviewRenderer(imageWrap, previewStatus, previewRetry);
    previewRetry.addEventListener('click', renderPreview);

    function money(value) { return `$${value}`; }
    function total() {
      const item = catalog[state.garment];
      return item.base + item.options.filter(option => state.selected.has(option.id)).reduce((sum, option) => sum + option.price, 0);
    }
    function selectedNames() {
      return catalog[state.garment].options.filter(option => state.selected.has(option.id)).map(option => option.name);
    }
    function currentBase() {
      const cropped = state.selected.has('crop') ? 'crop' : 'full';
      if (state.garment === 'shirt') return catalog.shirt.bases[state.view][cropped];
      const opening = state.selected.has('sherpa-interior') ? 'open' : 'closed';
      return catalog.jacket.bases[opening][cropped];
    }
    function renderPreview() {
      rememberDesign();
      const item = catalog[state.garment];
      const svg = buildPreview(state.garment, state.selected, state.view);
      const fragment = document.createElement('template');
      fragment.innerHTML = svg;
      const urls = [...fragment.content.querySelectorAll('image')].map(image => image.getAttribute('href'));
      showPreview(svg, `${state.view === 'back' ? 'Back' : 'Front'} view of ${item.name}${selectedNames().length ? ' with ' + selectedNames().join(', ') : ''}`, urls);
      viewToggle.hidden = state.garment !== 'shirt';
      viewToggle.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === state.view)));
    }
    function renderOptions() {
      const item = catalog[state.garment];
      optionsEl.innerHTML = item.options.map(option => {
        const disabled = state.garment === 'jacket' && option.id === 'sherpa-cuffs' && state.selected.has('sherpa-sleeves');
        const compactName = { 'fringe-sleeves': 'Sleeves', 'fringe-chest': 'Chest', 'fringe-back': 'Back', 'sherpa-collar': 'Collar', 'sherpa-cuffs': 'Cuffs', 'sherpa-sleeves': 'Sleeves', 'sherpa-interior': 'Lining', crop: 'Crop', embroider: 'Embroider' }[option.id];
        return `
        <label class="option${disabled ? ' is-disabled' : ''}${state.selected.has(option.id) ? ' is-selected' : ''}" data-detail="${option.id}">
          <input type="checkbox" value="${option.id}" aria-label="${option.name}. ${disabled ? 'Included with full sherpa sleeves' : option.detail + '. Add ' + money(option.price)}" ${state.selected.has(option.id) ? 'checked' : ''} ${disabled ? 'disabled' : ''}>
          <span class="option-copy">${compactName}</span>
        </label>`;
      }).join('');
      optionsEl.querySelectorAll('input').forEach(input => input.addEventListener('change', () => {
        input.checked ? state.selected.add(input.value) : state.selected.delete(input.value);
        if (input.value === 'sherpa-sleeves' && input.checked) state.selected.delete('sherpa-cuffs');
        if (state.garment === 'shirt' && input.value === 'fringe-back' && input.checked) state.view = 'back';
        if (state.garment === 'shirt' && ['fringe-sleeves', 'fringe-chest', 'embroider'].includes(input.value) && input.checked) state.view = 'front';
        renderOptions();
        optionsEl.querySelector(`input[value="${input.value}"]`)?.focus({preventScroll:true});
        renderSummary();
        renderPreview();
      }));
    }
    function renderSummary() {
      const names = selectedNames();
      priceEl.textContent = money(total());
      noteEl.textContent = names.length ? names.join(' · ') : 'Original garment. No details added.';
    }
    function chooseGarment(key) {
      if (key === state.garment) return;
      savedDesigns[state.garment] = new Set(state.selected);
      state.garment = key;
      state.selected = new Set(savedDesigns[key]);
      state.view = 'front';
      document.querySelectorAll('[data-garment]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.garment === key)));
      renderOptions();
      renderSummary();
      renderPreview();
    }
    document.querySelectorAll('[data-garment]').forEach(button => button.addEventListener('click', () => chooseGarment(button.dataset.garment)));
    document.getElementById('reset-design').addEventListener('click', () => {
      state.selected.clear(); state.view = 'front'; renderOptions(); renderSummary(); renderPreview();
    });
    if ('IntersectionObserver' in window) {
      // Keep the mobile bar out of layout in BOTH states. Otherwise hiding it
      // changes the observed studio height and retriggers this observer forever.
      document.body.classList.add('studio-dock-ready');
      new IntersectionObserver(entries => {
        document.body.classList.toggle('in-studio', entries[0].isIntersecting);
      }, {threshold:0, rootMargin:'-80px 0px -100px 0px'}).observe(document.getElementById('studio'));
    }
    viewToggle.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      state.view = button.dataset.view;
      renderPreview();
    }));

    // Warm the detail being considered without downloading every garment on mobile.
    optionsEl.addEventListener('pointerover', event => {
      const value = event.target.closest('.option')?.querySelector('input')?.value;
      const option = catalog[state.garment].options.find(detail => detail.id === value);
      if (option?.layer) { const image = new Image(); image.src = window.PapasDenimAssets[option.layer.replace('assets/layers/', 'assets/')]; }
    }, {passive:true});

    createPapasBookingPage(() => ({
      garment:catalog[state.garment].shortName,
      basePrice:money(catalog[state.garment].base),
      details:selectedNames(),
      lineItems:catalog[state.garment].options.filter(option => state.selected.has(option.id)).map(option => ({
        name:option.name.replace('Sherpa — full sleeve','Sherpa sleeves').replace('Sherpa — full interior','Sherpa lining').replace(' — ',' '),
        price:money(option.price)
      })),
      estimate:money(total())
    }));

    document.querySelectorAll('[data-garment]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.garment === state.garment)));
    renderOptions();
    renderSummary();
    renderPreview();
  
})();
